import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/index';
import {Observable} from 'rxjs/index';
import { CookieService} from 'ngx-cookie-service';
import { AppInfoService } from 'src/app/shared/services';
import { FormItemBase } from '../models/form-item-base';
import { WorksheetModel } from '../models/worksheet-model';
import { formLayoutEnum } from './formLayoutEnum'
import { stringify } from 'querystring';
import { diagnosisStatusEnum } from './diagnosisStatusEnum';
import { timer } from 'rxjs';
import { RecursiveTemplateAstVisitor } from '@angular/compiler';
import { ResetPasswordModel } from '../models/reset-password-model';

// To make a singleton
@Injectable({
  providedIn: 'root'
})


export class FormItemControlService {
  year: string;
  organ: string;
  formItemDict: {};
  public FormLayout = formLayoutEnum;
  public formLayout: formLayoutEnum;
  public formLayoutObservable: BehaviorSubject<formLayoutEnum> = new BehaviorSubject(formLayoutEnum.FullScreen);
  public formErrorObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public formErrorMsgObservable: BehaviorSubject<string> = new BehaviorSubject('');
  public formLoading: boolean;
  public formLoadingObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public isLoggedIn: boolean;
  public isLoggedInObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public isPasswordExpired: boolean;
  public isPasswordExpiredObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public loggedInUser: string;
  public loggedInUserObservable: BehaviorSubject<string> = new BehaviorSubject('');

  public diagnosisStatus: diagnosisStatusEnum;
  public diagnosisStatusObservable: BehaviorSubject<diagnosisStatusEnum> = new BehaviorSubject(diagnosisStatusEnum.Unknown);
  public diagnosisStatusMsg: string;
  public diagnosisStatusMessageObservable: BehaviorSubject<string> = new BehaviorSubject('');

  public resultsLayoutSupported: boolean;
  public resultsLayoutSupportedObservable: BehaviorSubject<boolean> = new BehaviorSubject(true);

  public errorList: Array<any>;
  public errorListObservable: BehaviorSubject<Array<any>> = new BehaviorSubject(null);

  public token: string;
  public refreshToken: string;

  worksheets: Array<WorksheetModel>;

  bAllowUpdates: boolean;

  userInputQueue = new Array();
  subscribeTimer: any;
  timerCounter: number;

  private appInfoService = null;
  private cookieService = null;

  constructor(appInfoService: AppInfoService, cookieService: CookieService) {
    console.log('FormItemControlService constructor');
    this.appInfoService = appInfoService;
    this.cookieService = cookieService;
    this.formItemDict = {};
    this.worksheets = new Array();
    this.bAllowUpdates = true;
    this.formLayout = formLayoutEnum.FullScreen;
    this.isLoggedIn = false;
    this.loggedInUser = '';
    this.timerCounter = 0;

    this.setIsLoggedInObservable(this.isLoggedIn, '', '', '', false);

    this.observableTimer();

    const accessToken = this.cookieService.get('polusws-token');
    const refreshToken = this.cookieService.get('polusws-refreshtoken');
    const passwordExpired = this.cookieService.get('polusws-pwexpired');
    const expiresTime = this.cookieService.get('polusws-expirestime');  
    const loggedInUser = this.cookieService.get('polusws-user');

    if (accessToken != null && 
        refreshToken != null &&
        expiresTime != null) {
      const expirationTime = new Date(Date.parse(expiresTime));
      const now = new Date();
      if (now < expirationTime) {
        this.setIsLoggedInObservable(true, accessToken, refreshToken, loggedInUser, passwordExpired.toLowerCase() == 'true')
      }
      else {
        this.clearCookies();
      }
    }
  }

  observableTimer() {
    const source = timer(250, 250);
    const abc = source.subscribe(val => {
      this.processQueue();

      // Send a status request once a minute to see if inactive
      if (this.isLoggedIn) {
        this.timerCounter++;
        if ((this.timerCounter % 240) == 0) {
          this.appInfoService.getStatus(this.token).subscribe({
            error: (data: any) => {
              if (data != null) {
                if (data.status == 401) {
                 this.setFormErrorObservable(true, 'Logged off due to inactivity');
                 this.logoff();
                } 
              }
            }});
        }
      }
    });
  }

  public enqueueUserInput = function(e) {
    this.userInputQueue.push(e);
    console.log('enqueueUserInput: ' + e.controlID + ' , queue length: ' + this.userInputQueue.length);
  };

  public getUser = function() {
    return this.cookieService.get('polusws-user');
  }

  private dequeueUserInput = function() {
    const postParams = this.userInputQueue.shift();

    if (postParams != null) {
      console.log('dequeueUserInput: ' + postParams.controlID + ', queue length: ' + this.userInputQueue.length);
    }

    return postParams;
  };

  private isUserInputQueueEmpty = function() {
    return this.userInputQueue.length === 0;
  };

  private peekUserInputQueue = function() {
    return !this.isUserInputQueueEmpty() ? this.userInputQueue[0] : undefined;
  };

  private processQueue = function() {
    if (this.AllowUpdates && !this.isUserInputQueueEmpty()) {
      let postParams = this.dequeueUserInput();

      while (postParams != null) {
        console.log('processQueue: controlID: ' + postParams.controlID + ', newValue: ' + postParams.newValue);
        this.updateFormItems(postParams.controlID, postParams.newValue, postParams.bLookupOption, this.isUserInputQueueEmpty());
        postParams = this.dequeueUserInput();
      }
    }
  };

  login(userName: string, password: string, context: any, callback: any) {
    this.setFormLoadingObservable(true);
    let bRet = false;
    let statusMsg = '';

    this.appInfoService.getToken(userName, password).subscribe({
      next: (data: any) => {
        this.setIsLoggedInObservable(true, data.access_token, data.refresh_token, data.userName, data.passwordExpired == "true" ? true : false);
        bRet = true;

        if (context != null && callback != null) {
          callback(context, bRet, statusMsg);
        }

        const expiresTime = data['.expires'];
        this.cookieService.set('polusws-token', data.access_token);
        this.cookieService.set('polusws-refreshtoken', data.refresh_token);
        this.cookieService.set('polusws-pwexpired', data.passwordExpired);
        this.cookieService.set('polusws-expirestime', expiresTime);
        this.cookieService.set('polusws-user', data.userName);
      },
      error: (e) => {
        this.setIsLoggedInObservable(false, '', '', '', false);
        statusMsg = 'Login attempt failed.';
        bRet = false;

        if (context != null && callback != null) {
          callback(context, bRet, statusMsg);
        }

        this.clearCookies();
      },
      complete: (e) => {

      }});
  } 

  forceTokenRefresh() {
    this.appInfoService.refreshToken(this.token, this.refreshToken).subscribe({
      next: (data: any) => {
        if (data.refresh_token != null) {
          this.token = data.access_token;
          this.refreshToken = data.refresh_token;

          const expiresTime = data['.expires'];
          this.cookieService.set('polusws-token', data.access_token);
          this.cookieService.set('polusws-refreshtoken', data.refresh_token);
          this.setFormErrorObservable(false, '');
        }
      },
      error: (data: any) => {
        // tslint:disable-next-line: max-line-length
        if (data != null)
        {
          if (data.status == 400) {
           this.setFormErrorObservable(true, 'Session Expired: Please logout and log back in to restore connection.');
          }
        } else {
         this.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
         this.forceTokenRefresh();
        }
        this.setFormLoadingObservable(false);
      },
      complete: () => {
        this.AllowUpdates = true;
      }});
  }

  logoff() {
    this.appInfoService.logoff(this.token, this.refreshToken).subscribe({
      next: (data: any) => {

      },
      complete: () => {
        this.setFormErrorObservable(false, '');
        this.setIsLoggedInObservable(false, '', '', '', false);
        this.clearCookies();
      },
      error: () => {
        this.clearCookies();
      }
    
    });

  }

  resetPassword(resetPasswordModel: ResetPasswordModel, context: any, callback: any) {
    this.setFormLoadingObservable(true);
    let bRet = false;
    let statusMsg = '';

    this.appInfoService.resetPassword(this.token, this.loggedInUser, resetPasswordModel.oldPassword, resetPasswordModel.newPassword).subscribe({
      next: (data: any) => {
        this.setIsLoggedInObservable(true, this.token, this.refreshToken, this.loggedInUser, false);
        bRet = true; 

        if (context != null && callback != null) {
          callback(context, bRet, statusMsg);
        }
        this.forceTokenRefresh();
      },
      error: (e) => {
        //this.setIsLoggedInObservable(false, '', '', '', false);
        statusMsg = 'Change password failed.';
        bRet = false;

        if (context != null && callback != null) {
          callback(context, bRet, statusMsg);
        }
        this.forceTokenRefresh();
      },
      complete: (e) => {

      }});
  }

  setLoadedWorksheets(worksheets) {
    if (worksheets != null) {
      worksheets.forEach(e1 => {
        const newWorksheet = new WorksheetModel(e1);
        newWorksheet.categorizeControls(e1);
        this.worksheets.push(newWorksheet);
      });
    } else {
      // Clear out worksheets if null
      this.worksheets = null;
    }
  }

  getLoadedWorksheets() {
    return this.worksheets;
  }

  getCurrentWorksheet() {
    let ret = null;

    if (this.worksheets != null && this.worksheets.length > 0 && this.year != null) {
      if (this.year.length > 0 && this.organ.length > 0 && this.worksheets != null) {
        const path = this.organ + '/' + this.year;
        ret = this.worksheets.find(e => e.path === path);
      }
    }

    return ret;
  }

  getWorksheetControl(controlID: string) {
    let ret = null;

    const worksheet = this.getCurrentWorksheet();
    if (worksheet) {
      ret = worksheet.controlsDict[controlID];
    }

    return ret;
  }

  setWorksheetParams(organ: string, year: string) {
    this.organ = organ;
    this.year = year;
  }

  updateCurrentWorksheet(worksheetData: any) {
    if (worksheetData != null && worksheetData.ControlList) {
      this.setDiagnosisStatusObservable(worksheetData.DiagnosisStatus, worksheetData.DiagnosisStatusMessage);

      let bWorksheetErrorsExist = false;
      let bWorksheetWarningsExist = false;

      // update the error list
      this.errorList = new Array();
      if (!worksheetData.IsFirstUpdate && worksheetData.ValidationErrors != null && worksheetData.ValidationErrors.length > 0) {
        worksheetData.ValidationErrors.forEach(e1 => {
          if (e1.Severity === 1) {
            bWorksheetErrorsExist = true;
          } else if (e1.Severity === 0) {
            bWorksheetWarningsExist = true;
          }
          this.errorList.push(e1);
        });
      }

      worksheetData.ControlList.forEach(control => {
        const formItem = this.formItemDict[control.ID];

        if (control.ID == 'HE_USED')
        {
            console.log("stop");
        }

        if (formItem != null) {
          if (formItem.controlType === 'dropdown') {
            for (let i = 0; i < formItem.optionVals.length; i++) {
              if (formItem.optionVals[i].toString() === control.Value) {
                formItem.value = formItem.optionStrs[i];
                break;
              }
            }
        } else if (formItem.controlType === 'checkbox') {
          if (formItem.value != null && formItem.value.toString() !== control.Value.toString()) {
            formItem.value = control.Value;
            formItem.boolValue = (formItem.value === 'true') ? true : false;
          }
        } else if (formItem.controlType === 'button') {
          this.updateFormItemButton(formItem, bWorksheetErrorsExist, bWorksheetWarningsExist);
        } else if (formItem.controlType === 'multilinetextbox') {
              if (formItem.value != null && formItem.value.toString() !== control.Value.toString()) {
                formItem.value = control.Value;
              }
              this.updateFormItemButton(formItem, bWorksheetErrorsExist, bWorksheetWarningsExist);
        } else {
            if (formItem.value != null && formItem.value.toString() !== control.Value.toString()) {
              formItem.value = control.Value;
            }
          }

          formItem.isEnabled = control.IsEnabled;
          formItem.isReadOnly = control.IsReadOnly;
          formItem.isVisible = control.IsVisible;
          formItem.useAltText = control.UseAltText;
          formItem.invalidValue = control.InvalidValue;
          formItem.selectedLabel = formItem.label;
          formItem.errorHint = control.ErrorHint;
          formItem.bWorksheetErrorsExist = bWorksheetErrorsExist;
          formItem.bWorksheetWarningsExist = bWorksheetWarningsExist;

          if (formItem.useAltText) {
            if (formItem.altlabel != null && formItem.altlabel.length > 0) {
              formItem.selectedLabel = formItem.altlabel;
            }
          }
        }

        // Update the current worksheet value cache as to not lose value changes on the server side.
        const worksheetControl = this.getWorksheetControl(control.ID);

        if (worksheetControl != null) {
          worksheetControl.Value = control.Value;
        }
      });

      this.setErrorListObservable(this.errorList);

    }
  }

  updateFormItemButton(formItem, bErrorsExist, bWarningsExist) {
    if (bErrorsExist && formItem.alertLevel === 'error') {
      formItem.bAlertUser = true;
      formItem.alertMessage = 'Worksheet errors exist.  Do you wish to proceed with the current action?';
      formItem.icon = 'warning';
    } else if ((bErrorsExist || bWarningsExist) && formItem.alertLevel === 'warning') {
      formItem.bAlertUser = true;
      formItem.alertMessage = 'Worksheet errors and/or warnings exist.  Do you wish to proceed with the current action?';
      formItem.icon = 'warning';
    }
    else if (formItem.alertLevel === 'reset') {
      formItem.bAlertUser = true;
      formItem.alertMessage = 'There is no way to recover worksheet values once reset.  Do you wish to proceed with the current action?';
    }
    else{
      formItem.bAlertUser = false;
      formItem.alertMessage = '';
      formItem.icon = '';
    }
  }

  resetFormItemDict() {
    if (this.formItemDict != null) {
      this.formItemDict = {};
    }
  }

  addFormItemToDict(formItem: FormItemBase<string>) {
    const val = this.formItemDict[formItem.key];

    if (val === undefined) {
      // console.log('addFormItemToDict: ' + formItem.key);
      this.formItemDict[formItem.key] = formItem;
    }
  }

  lookupFormItemFromDict(key: string) {
    const ret = this.formItemDict[key];

    return ret;
  }

  getFormLayoutObservable(): Observable<formLayoutEnum> {
    return this.formLayoutObservable.asObservable();
  }

  setFormLayoutObservable(formLayout: formLayoutEnum) {
    this.formLayoutObservable.next(formLayout);
  }

  getFormErrorObservable() {
    return this.formErrorObservable.asObservable();
  }

  getFormErrorMsgObservable() {
    return this.formErrorMsgObservable;
  }

  setFormErrorObservable(bIsError: boolean, errorMsg: string) {
    this.formErrorObservable.next(bIsError);
    this.formErrorMsgObservable.next(errorMsg);
  }

  getDiagnosisStatusObservable() {
    return this.diagnosisStatusObservable;
  }

  getDiagnosisStatusMessageObservable() {
    return this.diagnosisStatusMessageObservable;
  }

  setDiagnosisStatusObservable(status: diagnosisStatusEnum, msg: string) {
    this.diagnosisStatusObservable.next(status);
    this.diagnosisStatusMessageObservable.next(msg);
  }

  getFormLoadingObservable()
  {
    return this.formLoadingObservable;
  }

  setFormLoadingObservable(bLoading: boolean)
  {
    this.formLoadingObservable.next(bLoading);
  }

  getIsLoggedInObservable()
  {
    return this.isLoggedInObservable;
  }

  clearCookies()
  {
    this.cookieService.delete('polusws-token');
    this.cookieService.delete('polusws-refreshtoken');
    this.cookieService.delete('polusws-pwexpired');
    this.cookieService.delete('polusws-expirestime');
    this.cookieService.delete('polusws-user');
  }

  setIsLoggedInObservable(isLoggedIn: boolean, token: string, refreshToken: string, loggedInUser: string, isPasswordExpired: boolean)
  {
    this.token = token;
    this.refreshToken = refreshToken;
    
    this.isPasswordExpired = isPasswordExpired;
    this.isPasswordExpiredObservable.next(isPasswordExpired);

    this.loggedInUser = loggedInUser;
    this.loggedInUserObservable.next(loggedInUser);

    if (!isPasswordExpired) {
      this.isLoggedIn= isLoggedIn;
      this.isLoggedInObservable.next(isLoggedIn);
    }
  }

  getLoggedInUserObservable()
  {
    return this.loggedInUserObservable;
  }

  getIsPasswordExpiredObservable()
  {
    return this.isPasswordExpiredObservable;
  }

  getResultsLayoutSupportedObservable()
  {
    return this.resultsLayoutSupportedObservable;
  }

  setResultsLayoutSupportedObservable(bSupported: boolean)
  {
    this.resultsLayoutSupportedObservable.next(bSupported);
  }

  getErrorListObservable() {
    return this.errorListObservable;
  }

  setErrorListObservable(errorList: Array<any>) {
    this.errorListObservable.next(errorList);
  }

  public get AllowUpdates() {
    return this.bAllowUpdates;
  }

  public set AllowUpdates(bAllow: boolean) {
    this.bAllowUpdates = bAllow;
  }

  newGuid() {
    var result = '';
    var hexcodes = "0123456789abcdef".split("");

    for (var index = 0; index < 32; index++) {
        var value = Math.floor(Math.random() * 16);

        switch (index) {
        case 8:
            result += '-';
            break;
        case 12:
            value = 4;
            result += '-';
            break;
        case 16:
            value = value & 3 | 8;
            result += '-';
            break;
        case 20:
            result += '-';
            break;
        }
        result += hexcodes[value];
    }
    return result;
  };

  public loadWorksheetValues(loadedWorksheet) {
    const worksheet = this.getCurrentWorksheet();

    //Reset the worksheet

    /*
    this.appInfoService.updateWorksheet(this.token, worksheet).subscribe({
      next: (data: any[]) => {
           console.log('updateWorksheet: next');
           this.AllowUpdates = false;
           this.updateCurrentWorksheet(data);
           this.setFormLoadingObservable(false);

           // Refresh the expiration date of the token
          //this.forceTokenRefresh();

          worksheet.ForceReset = false;
          console.log(loadedWorksheet);
          //delete loadedWorksheet.controlsDict["NUM_GLOMERULI"];
          //console.log(loadedWorksheet.controlsDict["NUM_GLOMERULI"]);
          //Set the worksheet values to those of the loaded worksheet. Make note of any discrepancies
          

     },
     error: (data: any) => {
       // tslint:disable-next-line: max-line-length
       if (data != null)
       {
         if (data.status == 401) {
          this.setFormErrorObservable(true, 'Logged off due to inactivity');
          this.logoff();
         } else {
          this.setFormErrorObservable(true, 'Failed to update the worksheet.  Error: ' + data.status + ', ' + data.statusText);
          this.forceTokenRefresh();
         }
       } else {
        this.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
        this.forceTokenRefresh();
       }
       this.setFormLoadingObservable(false);
       return "Load Failed";
     }
   });
   */

   var loadMessage = "";
          
    for(let control in loadedWorksheet.controlsDict){
      if(worksheet.controlsDict[control]){
        worksheet.controlsDict[control].Value = loadedWorksheet.controlsDict[control].Value; 
      }
      else{
        if(loadMessage != ""){
          loadMessage += ("\n");
        }
        loadMessage += (loadedWorksheet.controlsDict[control].Text + " could not be loaded.");
      }
    }
  
  
    for(let control in worksheet.controlsDict){
      if(loadedWorksheet.controlsDict[control]){
  
      }
      else {
        if(loadMessage != ""){
          loadMessage += ("\n");
        }
        loadMessage += (worksheet.controlsDict[control].Text + " is missing from the loaded case.");
      }
    }
  
    if(loadMessage == ""){
      loadMessage = "Load Successful";
    }
  
    //worksheet.IsFirstUpdate = true;
  
    this.appInfoService.updateWorksheet(this.token, worksheet).subscribe({
      next: (data: any[]) => {
          console.log('updateWorksheet: next');
          this.AllowUpdates = false;
          this.updateCurrentWorksheet(data);
          this.setFormLoadingObservable(false);
  
          // Refresh the expiration date of the token
          this.forceTokenRefresh();
    },
    error: (data: any) => {
      // tslint:disable-next-line: max-line-length
      if (data != null)
      {
        if (data.status == 401) {
          this.setFormErrorObservable(true, 'Logged off due to inactivity');
          this.logoff();
        } else {
          this.setFormErrorObservable(true, 'Failed to update the worksheet.  Error: ' + data.status + ', ' + data.statusText);
          this.forceTokenRefresh();
        }
      } else {
        this.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
        this.forceTokenRefresh();
      }
      this.setFormLoadingObservable(false);
    }
    });

    return loadMessage;


  }

  public updateFormItems(controlID, newValue, bLookupOption, bPostIt) {
    // Update the form items with the updated control values
   console.log('updateFormItems: bPostIt: ' + bPostIt);
   const worksheet = this.getCurrentWorksheet();

   if (controlID != null) {
     if (worksheet.controlsDict[controlID] != null) {
       const control = worksheet.controlsDict[controlID];

       if (!bLookupOption) {
         if (!(control.Value === newValue)) {
          control.Value = newValue;
         }
         
       } else {
         control.ValueOptions.forEach(e => {
           if (e.Text === newValue) {
             control.Value = e.Value;
             return false; // effectively a break
           }
         });
       }
     }
     if (bPostIt) {
       worksheet.IsFirstUpdate = false; // Not initial update
       worksheet.ModifiedControlID = controlID; // Special key to let the server know which control changed 
       this.AllowUpdates = false;
       this.setFormLoadingObservable(true);

       console.log('updateWorksheet: posting...');
       this.appInfoService.updateWorksheet(this.token, worksheet).subscribe({
          next: (data: any[]) => {
               console.log('updateWorksheet: next');
               this.AllowUpdates = false;
               this.updateCurrentWorksheet(data);
               this.setFormLoadingObservable(false);

               // Refresh the expiration date of the token
              this.forceTokenRefresh();
         },
         error: (data: any) => {
           // tslint:disable-next-line: max-line-length
           if (data != null)
           {
             if (data.status == 401) {
              this.setFormErrorObservable(true, 'Logged off due to inactivity');
              this.logoff();
             } else {
              this.setFormErrorObservable(true, 'Failed to update the worksheet.  Error: ' + data.status + ', ' + data.statusText);
              this.forceTokenRefresh();
             }
           } else {
            this.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
            this.forceTokenRefresh();
           }
           this.setFormLoadingObservable(false);
         }
       });
     }
   }
 }

}
